import React, { useState } from 'react';
import {CheckMark, LoadingIcon, ResendInvite} from "../../assets/icons/Icons";
import {resendUserInvite} from "../../api/users/resendUserInvite";
import MessageError from "../MessageError";
import {useTranslation} from "react-i18next";
import CustomTooltip from "../CustomTooltip";
import {Link} from "react-router-dom";

const ResendInviteLink = ({user_id, ...props}) => {
    const { t } = useTranslation();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [sent, setSent] = useState(false);
    const resendInvite = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        try {
            await resendUserInvite(user_id);
            setLoading(false);
            setSent(true);
        } catch (err){
            setError(err.message);
            setLoading(false);
            console.log("Error fetching data: " + err);
        }
    }
    return (
        <>
            {props.showAsTooltip ? <Link to="#" onClick={resendInvite} disabled={sent}>
                {sent ? <CustomTooltip icon={<CheckMark/>} message={t('Invite sent')}/> :
                    <CustomTooltip icon={<ResendInvite/>} message={t('Resend Invite')}/>}
            </Link> : <button
                className={`btn btn-secondary btn-medium ml-2 ${loading ? 'btn-loading' : ''}`}
                onClick={resendInvite} disabled={sent}>
                {loading && <LoadingIcon/>}
                {sent ? t('Invite sent') : t('Resend Invite')}
            </button>}
            <MessageError error={error} className="mt-1"/>
        </>


    );
};

export default ResendInviteLink;
